"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.EmptyWrappedPromiseState = EmptyWrappedPromiseState;
exports.connectAAARefetch = connectAAARefetch;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactRefetch = require("react-refetch");

var _lodash = require("lodash");

var _hoistNonReactStatics = require("hoist-non-react-statics");

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function EmptyWrappedPromiseState() {
    return {
        value: null
    };
}
// augments refetch objects with dismissable error handlers.
// supplies dismiss all errors, wit just removes are error flags entirely.
function connectAAARefetch(refetchSelectorFunction) {
    var debugStateChanges = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

    function debugStateChange() {
        if (__DEVELOPMENT__ && debugStateChanges) {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            console.debug.apply(console, args);
        }
    }
    return function connectAAARefetchInner(TargetComponent) {
        var ConnectAAARefetchHOC = function (_Component) {
            _inherits(ConnectAAARefetchHOC, _Component);

            function ConnectAAARefetchHOC(props) {
                _classCallCheck(this, ConnectAAARefetchHOC);

                var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ConnectAAARefetchHOC).call(this, props));

                _this.dismissAllRefetchErrors = function () {
                    // augments all promiseStates and removes their error flags if currently set.
                    debugStateChange("ConnectAAARefetchHOC.dismissAllRefetchErrors: dismissing all errors");
                    // flag all errors as dismissed.
                    var newErrorMap = (0, _lodash.mapValues)(_this.state.errorMap, function (val, key) {
                        return true; // flag item as dismissed!
                    });
                    _this.setState({
                        errorMap: newErrorMap
                    });
                };
                var errorMap = {}; // hides encountered erros
                var stateMap = {}; // keeps the last known working state
                // loop through all known promiseStates and set their errors
                // Heads up: potentially not all PromiseStates are available in props while constructing this component?
                // this edgecase is currently not supported, no undefined states are allowed.
                (0, _lodash.mapValues)(_this.props, function (prop, key) {
                    if (prop instanceof _reactRefetch.PromiseState) {
                        errorMap[key] = false;
                        stateMap[key] = prop.value;
                    }
                });
                // console.log(errorMap);
                // set the initialValues of this internal state...
                _this.state = {
                    errorMap: errorMap,
                    stateMap: stateMap
                };
                return _this;
            }

            _createClass(ConnectAAARefetchHOC, [{
                key: "componentWillReceiveProps",
                value: function componentWillReceiveProps(nextProps) {
                    var _this2 = this;

                    // decide if the error shallowing can be removed here
                    // (a new request is made, the promiseState transitions into pending, hence our the components internal error state can be removed)
                    // go through all promiseStates, if their error flag was removed, remove our internal state as well
                    // console.log("componentWillReceiveProps", nextProps);
                    // every promiseState that transitions from settled===true to settled===false must reset the errorMap state.
                    var newErrorMap = this.state.errorMap;
                    var newStateMap = this.state.stateMap;
                    (0, _lodash.mapValues)(nextProps, function (prop, key) {
                        if (prop instanceof _reactRefetch.PromiseState) {
                            // reset dismissed errors back while we are in the loading state.
                            if (prop.settled === false && _this2.props[key] && _this2.props[key].settled === true || prop.refreshing === true && _this2.props[key] && _this2.props[key].refreshing === false) {
                                debugStateChange("ConnectAAARefetchHOC.componentWillReceiveProps: resetting promiseState for " + key + " as settled has been changed", prop);
                                newErrorMap[key] = false;
                            }
                            // remember the fulfilled value in the state, on errors use the cached value
                            if (prop.fulfilled === true && _this2.props[key] && _this2.props[key].fulfilled === false) {
                                debugStateChange("ConnectAAARefetchHOC.componentWillReceiveProps: caching value of promiseState for " + key + " as fulfilled", prop);
                                newStateMap[key] = prop.value;
                            }
                        }
                    });
                    this.setState({
                        errorMap: newErrorMap,
                        stateMap: newStateMap
                    });
                }
            }, {
                key: "render",
                value: function render() {
                    var _this3 = this;

                    // console.log("HOC", this.props);
                    var _state = this.state;
                    var errorMap = _state.errorMap;
                    var stateMap = _state.stateMap;

                    var augmentedProps = (0, _lodash.mapValues)(this.props, function (prop, key) {
                        if (prop instanceof _reactRefetch.PromiseState) {
                            // augment this promiseState
                            // We don't know the generic of the promiseState instance thus cannot construct the typed object.
                            var augmentedPromiseState = {
                                state: prop,
                                value: prop.value ? prop.value : stateMap[key] ? stateMap[key] : null,
                                error: prop.reason && errorMap[key] !== true ? prop.reason : null,
                                loading: prop.pending || prop.refreshing,
                                dismissError: function dismissError() {
                                    debugStateChange("ConnectAAARefetchHOC.dismissError: dismissing " + key + " error");
                                    var newErrorMap = _this3.state.errorMap;
                                    newErrorMap[key] = true; // flag this item as dismissed!
                                    _this3.setState({
                                        errorMap: newErrorMap
                                    });
                                }
                            };
                            // console.log(augmentedPromiseState);
                            return augmentedPromiseState;
                        }
                        return prop;
                    });
                    debugStateChange("ConnectAAARefetchHOC.render:", augmentedProps);
                    // all promiseState objects get autowrapped by our async representation...
                    return React.createElement(TargetComponent, __assign({}, augmentedProps, this.state, { dismissAllRefetchErrors: this.dismissAllRefetchErrors }));
                }
            }]);

            return ConnectAAARefetchHOC;
        }(_react.Component);
        ConnectAAARefetchHOC = __decorate([(0, _reactRefetch.connect)(refetchSelectorFunction)], ConnectAAARefetchHOC);
        // apply hoistStatics via hoist-non-react-statics here (copies static props, e.g. contextTypes)
        return (0, _hoistNonReactStatics2.default)(ConnectAAARefetchHOC, TargetComponent);
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/decorators/connectAAARefetch.tsx
 ** module id = 155
 ** module chunks = 0
 **/